import { useMutation } from '@tanstack/react-query'
import { resetPassword } from 'aws-amplify/auth'

import { sendEvent } from 'src/shared/api/events/send-event'

export const useRequestPasswordReset = () => {
  return useMutation({
    mutationFn: async (email: string) => {
      const result = await resetPassword({ username: email })
      sendEvent({ eventType: 'auth_password_reset_requested', info: { email } })
      return result
    },
    onError: (error: unknown) => {
      const errorName = error instanceof Error ? error.name : 'unknown'
      sendEvent({
        eventType: 'auth_password_reset_request_error',
        info: { error: errorName },
      })
    },
  })
}
